import { StyleSheet } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  firstCardContainerStyle: {
    marginLeft: 16.6,
  },
  lastCardContainerStyle: {
    marginRight: 16.6,
  },
  recommendedContainerStyle: {
    borderWidth: 1,
    borderColor: Colors.ocean,
    marginTop: 0,
    borderTopLeftRadius: 0,
  },
  flatListStyle: {
    marginBottom: 15,
  },
  flatListContentContainerStyle: {
    alignItems: 'flex-end',
  },
});
